import { Button, Modal, ModalFooter, Stepper } from '@statsbomb/kitbag-components';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { twJoin } from 'tailwind-merge';
import {
  closeAndResetRadarTemplateModalAtom,
  isRadarTemplateModalOpenAtom,
  radarTemplateModalActiveStepAtom,
} from '@/atoms/radar';
import { RadarTemplateReferenceData } from '@/components/modal/CreateRadarTemplateModal/radarTemplateReferenceData';
import { useRadarTemplateSteps } from '@/hooks/radar/useRadarTemplateSteps';
import { ContinueButton } from './ContinueButton';
import { CreateRadarTemplateModalHeader } from './CreateRadarTemplateModalHeader';
import { DoneButton } from './DoneButton';
import { MetricLimits } from './MetricLimits';
import { MetricSelect } from './MetricSelect';
import PositionGroupSelect from './PositionGroupSelect';

const CreateRadarTemplateModalBase = () => {
  const { t } = useTranslation(['modal', 'general']);
  const [activeStep, setActiveStep] = useAtom(radarTemplateModalActiveStepAtom);
  const closeAndResetRadarTemplateModal = useSetAtom(closeAndResetRadarTemplateModalAtom);
  const steps = useRadarTemplateSteps();

  const handleBackButton = () => {
    if (activeStep === 0) {
      closeAndResetRadarTemplateModal();
    } else {
      setActiveStep(activeStep - 1);
    }
  };

  return (
    <Modal ariaLabelledBy="create-custom-radar-modal" isOpen onCancel={closeAndResetRadarTemplateModal}>
      <CreateRadarTemplateModalHeader activeStep={activeStep} onCancel={closeAndResetRadarTemplateModal} />
      <div className="hidden md:block h-[70px] py-2 px-4 border-b border-canvas-secondary-main">
        <Stepper steps={steps} activeStep={activeStep} onClick={(_: MouseEvent, step: number) => setActiveStep(step)} />
      </div>
      <div
        className={twJoin(
          'w-full md:min-w-[600px] lg:!w-[920px] h-[600px] flex full-screen-dialog flex-1',
          activeStep === 1 && 'flex-col md:!flex-row',
          activeStep === 2 && 'flex-row-reverse',
        )}
      >
        {activeStep === 0 && <PositionGroupSelect />}
        {activeStep === 1 && <MetricSelect />}
        {activeStep === 2 && <MetricLimits />}
      </div>
      <ModalFooter>
        <Button onClick={handleBackButton} variant="ghost">
          {t(activeStep === 0 ? 'cancel' : 'back', { ns: 'general' })}
        </Button>
        {activeStep === 2 ? <DoneButton /> : <ContinueButton />}
      </ModalFooter>
    </Modal>
  );
};

export const CreateRadarTemplateModal = () => {
  const isRadarTemplateModalOpen = useAtomValue(isRadarTemplateModalOpenAtom);

  return (
    isRadarTemplateModalOpen && (
      <>
        <RadarTemplateReferenceData />
        <CreateRadarTemplateModalBase />
      </>
    )
  );
};
